import React from 'react';
import { render } from '@testing-library/react';
import { Scroll } from './Scroll';
import { BodyText } from '../BodyText';

describe('Scroll', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Scroll
				el="div"
				height="148.5px"
				width="50%"
				scrollIndicator
				data-auto-sel="automation-selector"
			>
				<BodyText>Lorem ipsum dolor sit amet</BodyText>
				<BodyText className="m-t-2">
					Lorem ipsum dolor sit amet
				</BodyText>
				<BodyText className="m-t-2">
					Lorem ipsum dolor sit amet
				</BodyText>
			</Scroll>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
